import { APP_BASE_TITLE } from 'const';

export const getPathName = (path: string): string => {
  if (path === '/') return APP_BASE_TITLE;

  return path.replace(/\//, '').replace(/-/g, ' ');
};
